// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"52":"6713391f","285":"4a31f5c2","440":"c1253dda","672":"15eaef6a","703":"c2033aa0","722":"9b4d4297","973":"08250817"}[chunkId] + ".chunk.js";
};